<div class="row">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name"/>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Refresh (Seconds)</label>
      <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group">
      <h3>Display Value</h3>        
      <select [(ngModel)]="w.display" class="form-select">
        <option>Latest</option>
        <option>Average</option>
        <option>Maximum</option>
        <option>Minimum</option>
        <option>Change</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="form-select">
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showLegend" /> Show Legend
    </div>
  </div>
</div>
<br/>
<br/>
<div class="row mb-3">
  <div class="col-lg-3">
    <button (click)="addItem()" class="btn btn-primary btn-block" type="submit" [disabled]="w.timeSeriesDetailList && w.timeSeriesDetailList.length >= 5">
      <i class="fa fa-line-chart"></i> Add Time Series
    </button>
  </div>
</div>

<div class="row" *ngIf="w && w.timeSeriesDetailList">
  <div class="col-lg-12">
    <tabset>
      <tab
        *ngFor="let tab of w.timeSeriesDetailList"
        [heading]="tab.uri == null ? 'Not Set' : tab.name == '' || tab.name == null ? tab.uri : tab.name"
        [active]="tab.active"
        (select)="tab.active = true"
        (deselect)="tab.active = false"
        [disabled]="tab.disabled"
        [removable]="tab.removable"
        (removed)="removeTimeSeries(tab)">

        <div class="row">
          <div class="col-lg-6">
            <div class="form-group input-group-sm">
              <label>Select Time Series</label>
              <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
              <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
            </div>
            <div class="form-group input-group-sm">
              <label>Display Name</label>
              <input type="text" size="20" [(ngModel)]="tab.name" class="form-control">
            </div>
            <div class="form-group input-group-sm">
              <label>Value Suffix</label>
              <input type="text" [(ngModel)]="tab.valueSuffix" class="input-group form-control"/>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
            </div>
          </div>
        </div>  
      </tab>
    </tabset>
  </div>
</div>  
  
